import { ready } from "~/core";

ready("storyPromo", ".storyPromo", (storyPromo) => {
  //---------- Const ----------//
  const storyPromoContainer = storyPromo.querySelector(".storyPromo__container");
  const nextButton = storyPromo.querySelector(".storyPromo__navigation-next");
  const previousButton = storyPromo.querySelector(
    ".storyPromo__navigation-previous"
  );
  const allStories = storyPromo.querySelectorAll(".storyPromo__story");

  //---------- Variables ----------//
  let currentStory = 0;

  //---------- Functions ----------//
  const isMobile = () => {
    return window.innerWidth < 768;
  };

  const animateInFromRight = (element) => {
    const animateInFromRightKeyFrames = [
      { transform: "translate(0, 0)", width: "100%", zIndex: 2 },
      {
        transform: "translate(calc(-100% - 1.25rem), -2.5rem)",
        width: "200%",
        zIndex: 2,
      },
    ];

    const animateInFromRightOption = {
      duration: 200,
      iterations: 1,
      fill: "none",
    };

    const animation = element.animate(
      animateInFromRightKeyFrames,
      animateInFromRightOption
    );

    animation.onfinish = () => {
      element.classList.remove("next");
      element.classList.add("active");
    };
  };

  const animateInFromLeft = (element) => {
    const animateInFromLeftKeyFrames = [
      { transform: "translate(0, 0)", width: "100%", zIndex: 2 },
      {
        transform: "translate(calc(50% + 1.25rem), -2.5rem)",
        width: "200%",
        zIndex: 2,
      },
    ];

    const animateInFromLeftOption = {
      duration: 200,
      iterations: 1,
      fill: "none",
    };

    const animation = element.animate(
      animateInFromLeftKeyFrames,
      animateInFromLeftOption
    );

    animation.onfinish = () => {
      element.classList.remove("previous");
      element.classList.add("active");
    };
  };

  const animateOutToRight = (element) => {
    const animateOutToRightKeyFrames = [
      { transform: "translate(0, 0)", width: "100%" },
      { transform: "translate(calc(200% + 1.25rem), 2.5rem)", width: "50%" },
    ];

    const animateOutToRightOption = {
      duration: 200,
      iterations: 1,
      fill: "none",
    };

    const animation = element.animate(
      animateOutToRightKeyFrames,
      animateOutToRightOption
    );

    animation.onfinish = () => {
      element.classList.remove("active");
      element.classList.add("next");
    };
  };

  const animateOutToLeft = (element) => {
    const animateOutToLeftKeyFrames = [
      { transform: "translate(0, 0)", width: "100%" },
      { transform: "translate(calc(-100% - 1.25rem), 2.5rem)", width: "50%" },
    ];

    const animateOutToLeftOption = {
      duration: 200,
      iterations: 1,
      fill: "none",
    };

    const animation = element.animate(
      animateOutToLeftKeyFrames,
      animateOutToLeftOption
    );

    animation.onfinish = () => {
      element.classList.remove("active");
      element.classList.add("previous");
    };
  };

  const showStoryInActiveSpot = (slideIndex, direction) => {
    if (!isMobile()) {
      allStories.forEach((story, index) => {
        if (index === slideIndex) {
          if (direction === "next") {
            animateInFromRight(story);
          } else if (direction === "previous") {
            animateInFromLeft(story);
          }
        }
      });
    } else {
      allStories.forEach((story, index) => {
        if (index === slideIndex) {
          story.classList.add("active");
        } else {
          story.classList.remove("active");
        }
      });
    }
  };

  const showStoryInPreviousSpot = (slideIndex, direction) => {
    if (slideIndex === 0) {
      slideIndex = allStories.length;
    }
    if (!isMobile()) {
      allStories.forEach((story, index) => {
        if (index === slideIndex - 1) {
          if (direction === "next") {
            animateOutToLeft(story);
          } else {
            story.classList.add("previous");
          }
        } else if (direction === "next") {
          story.classList.remove("previous");
        }
      });
    } else {
      allStories.forEach((story, index) => {
        if (index === slideIndex - 1) {
          story.classList.add("previous");
        } else {
          story.classList.remove("previous");
        }
      });
    }
  };

  const showStoryInNextSpot = (slideIndex, direction) => {
    if (slideIndex === allStories.length - 1) {
      slideIndex = -1;
    }
    if (!isMobile()) {
      allStories.forEach((story, index) => {
        if (index === slideIndex + 1) {
          if (direction === "previous") {
            animateOutToRight(story);
          } else {
            story.classList.add("next");
          }
        } else if (direction === "previous") {
          story.classList.remove("next");
        }
      });
    } else {
      allStories.forEach((story, index) => {
        if (index === slideIndex + 1) {
          story.classList.add("next");
        } else {
          story.classList.remove("next");
        }
      });
    }
  };

  var isLocked = false;

  const incrementStory = () => {
    if (isLocked) return;
    lockButtons();

    currentStory++;
    if (currentStory >= allStories.length) {
      currentStory = 0;
    }
    showStoryInActiveSpot(currentStory, "next");
    showStoryInPreviousSpot(currentStory, "next");
    showStoryInNextSpot(currentStory, "next");

    setTimeout(unlockButtons, 250);
  };

  const decrementStory = () => {
    if (isLocked) return;
    lockButtons();

    currentStory--;
    if (currentStory < 0) {
      currentStory = allStories.length - 1;
    }
    showStoryInActiveSpot(currentStory, "previous");
    showStoryInPreviousSpot(currentStory, "previous");
    showStoryInNextSpot(currentStory, "previous");
    setTimeout(unlockButtons, 250);
  };

  const lockButtons = () => {
    isLocked = true;
    nextButton.disabled = true;
    previousButton.disabled = true;
  };

  const unlockButtons = () => {
    isLocked = false;
    nextButton.disabled = false;
    previousButton.disabled = false;
  };

  //---------- Initilization ----------//
  const init = () => {
    showStoryInActiveSpot(currentStory, "next");
    showStoryInPreviousSpot(currentStory, "next");
    showStoryInNextSpot(currentStory, "next");

    nextButton.addEventListener("click", incrementStory);
    previousButton.addEventListener("click", decrementStory);
  };

  init();
});
